import { faArrowLeftLong, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const TravelerFloatingActions = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className='floating-button-container hide-on-print traveler-print-actions'>
        <div
          className='floating-button floating-button-skip-animation'
          onClick={() => navigate(-1)}
        >
          <FontAwesomeIcon icon={faArrowLeftLong} />
        </div>
      </div>
      <div className='floating-button-container-right hide-on-print traveler-print-actions'>
        <div
          className='floating-button floating-button-skip-animation'
          onClick={() => window.print()}
        >
          <FontAwesomeIcon icon={faPrint} />
        </div>
      </div>
    </>
  );
};

export default TravelerFloatingActions;
